import { registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import localeEN from '@angular/common/locales/en';
import localeENExtra from '@angular/common/locales/extra/en';
import localeITExtra from '@angular/common/locales/extra/it';
import localeIT from '@angular/common/locales/it';
import { LOCALE_ID, NgModule } from "@angular/core";
import { MAT_MENU_DEFAULT_OPTIONS } from '@angular/material/menu';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from '@angular/service-worker';
import { JwtModule } from '@auth0/angular-jwt';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as R from 'ramda';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { AppComponent } from "./app.component";
import { PCodeConfig } from './app.config';
import { AppRoutingModule } from "./app.routing";
import { GlobalState } from "./app.state";
import { AuthService } from './shared/services/authentication/auth.service';
import { NotificationsService } from './shared/services/notifications/notifications.service';

// localization
const USER_LOCALE = localStorage.getItem('user_lang') || 'it';
export class MultiTranslateHttpLoader implements TranslateLoader
{
	constructor(private http: HttpClient, public resources: { prefix: string; suffix: string }[] = [{ prefix: '/assets/translate/', suffix: '.json' }]) { }

	public getTranslation(lang: string)
	{
		return forkJoin(this.resources.map(config =>
		{
			return this.http.get(config.prefix + lang + config.suffix);
		}))
			.pipe(map(response =>
			{
				return (response as [][]).reduce((a, b) =>
				{
					return R.mergeDeepLeft(a, b);
				});
			}));
	}
}
export function HttpLoaderFactory(http: HttpClient)
{
	return new MultiTranslateHttpLoader(http,
		[
			{ prefix: "/assets/translate/core/", suffix: ".json" },
			{ prefix: "/assets/translate/admin/", suffix: ".json" }
		]);
}
registerLocaleData(localeIT, localeITExtra);
registerLocaleData(localeEN, localeENExtra);

// azure ad authentication function
function MSALInstanceFactory(): IPublicClientApplication
{
	if (PCodeConfig.azureAd.enabled && (!PCodeConfig.azureAd.tenantId || !PCodeConfig.azureAd.clientId))
		console.error("PCODE: Configurazione Azure AD mancante.");

	return new PublicClientApplication({
		auth:
		{
			clientId: PCodeConfig.azureAd.clientId,
			authority: `https://login.microsoftonline.com/${PCodeConfig.azureAd.tenantId}`,
			redirectUri: `${window.location.origin}/login`
		},
		cache:
		{
			cacheLocation: 'localStorage',
			storeAuthStateInCookie: (window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1),
		}
	});
}

// module
@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	imports:
		[
			AppRoutingModule,
			BrowserModule,
			BrowserAnimationsModule,
			JwtModule.forRoot(
				{
					config: {
						tokenGetter: AuthService.getAccessToken
					}
				}),
			TranslateModule.forRoot(
				{
					loader: {
						provide: TranslateLoader,
						useFactory: HttpLoaderFactory,
						deps: [HttpClient]
					}
				}),
			ServiceWorkerModule.register('ngsw-worker.js',
				{
					enabled: environment.production,
					registrationStrategy: 'registerWhenStable:30000'
				})
		],
	providers:
		[
			{ provide: LOCALE_ID, useValue: USER_LOCALE },
			{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
			{ provide: MAT_MENU_DEFAULT_OPTIONS, useValue: { overlayPanelClass: 'pcode-mat-menu' } },
			GlobalState,
			Title,
			NotificationsService,
			// azure ad msal service
			{
				provide: MSAL_INSTANCE,
				useFactory: MSALInstanceFactory
			},
			{
				provide: MSAL_GUARD_CONFIG,
				useValue: {
					interactionType: PCodeConfig.azureAd.interactionType,
					authRequest:
					{
						// enable this scope in azure API permissions (delegated)
						scopes: ['user.read', 'user.read.all', 'presence.read.all', 'offline_access']
					}
				} as MsalGuardConfiguration
			},
			MsalService,
			MsalBroadcastService,
			provideHttpClient(withInterceptorsFromDi())
		]
})

export class AppModule
{
	constructor()
	{

	}
}